@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.export-records-modal {
  width: 650px;
  margin: 30px 0;
}

.export-records-modal-body {
  padding: 15px;
}

.export-records-modal-footer {
  display: flex;
  justify-content: flex-end;
}

.save-column-button {
  cursor: pointer;
  margin: 0 10px;
  color: @export-records-modal--save-button--text-color;
  display: flex;
  align-self: start;
  padding-top: 5px;
  &.disabled {
    color: @export-records-modal--save-button--disabled--text-color;
  }
}

.remove-button {
  cursor: pointer;
}

.right-buttons {
  display: flex;
  align-items: center;
  > button {
    margin-left: 10px;
  }
}

.group {
  &:first-child {
    padding-bottom: 20px;
  }
}

.group-head {
  font-size: 18px;
  font-weight: 500;
  padding-bottom: 5px;
  color: @export-records-modal--group-head--text-color;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.radio-button-list {
  width: 100%;
}

.group-options {
  .option-row {
    width: 100%;
    display: flex;

    label {
      width: 100%;
      display: flex;
      align-items: center;
    }
  }

  .option-actions {
    margin-left: auto;
    margin-right: 25px;
    display: flex;
    align-items: center;
  }
}

.trash-wrapper {
  position: absolute;
  right: 0;
}

.lock-wrapper {
  position: absolute;
  right: 0;
}

.update-format-name {
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.form-error-message {
  color: @export-records-modal--form--error--text-color;
  margin-left: 10px;
  font-size: 12px;
}

.update-fields-label {
  font-weight: @bold;
  padding-top: 20px;
  font-size: 14px;
}

.update-fields {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 15px;

  ul {
    width: 260px;
    border: 1px solid @export-records-modal--update-fields-list-container--border-color;
    height: 230px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    font-size: 14px;
  }

  li {
    padding: 5px;
    border-bottom: 1px solid @export-records-modal--update-fields-list--border-color;
    cursor: pointer;
    background-color: @export-records-modal--update-fields-list--background-color;
    margin-left: 1px;
  }

  .active {
    background-color: @export-records-modal--update-fields--active--background-color;
  }

  .has-error {
    border: 1px solid @export-records-modal--update-fields--error--border-color;
  }

  .field-buttons {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    height: 150px;
  }
}

.hidden {
  display: none;
}

.input-width {
  width: 45%;
}

.selected-fields-wrap {
  position: relative;
  .add-fields-message,
  .form-error-message {
    margin: 0;
    position: absolute;
    top: -26px;
    width: 100%;
  }
  .add-fields-message {
    font-weight: 600;
    font-size: 14px;
  }
  .form-error-message {
    text-align: center;
  }
}

.selected-field-item {
  display: flex;
  flex-direction: column;

  .selected-field-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .edit-svg {
    height: 12px;

    &:hover {
      color: @export-records-modal--selected-field--hover--fill-color;
    }
  }

  .edit-field-name {
    display: flex;
    padding-top: 5px;
  }

  .original-field-name {
    color: @export-records-modal--selected-field--text-color;
    padding-top: 3px;
  }
}

.loading-indicator {
  height: 75px;
}

.delete-format-modal {
  width: 500px;

  .modal-body {
    padding: 20px 15px 50px;
    max-height: 300px;
  }

  .modal-footer {
    > button {
      margin-left: 10px;
    }
  }
}
